import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "MyAssociationRequest" })
export default class MyAssociationRequest extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public isVerified: boolean = false;
    public isCreating: boolean = false;
    public isGeoMarkerExist: boolean = false;
    public googlePlaceId: string = null;
    public selectedGeoMarker: string = null;
    public formData: any = { market: null, marketType: null, type: null };
    public geoMarker: any = {};
    public geoMarkers: any[] = [];
    public validationErrors: any[] = [];
    public geoMarkerTypes: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    public async checkGooglePlaceId() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            const result = (await Axios.post(this.routes.MyBremboPartsExpert_CheckGooglePlaceId, { googlePlaceId: this.googlePlaceId })).data;

            this.isGeoMarkerExist = result.isGeoMarkerExist;
            this.geoMarkers = result.geoMarkers;
            this.geoMarker = result.geoMarker;

            this.isVerified = true;
            this.isCreating = this.geoMarkers.length === 0;

            if (this.isCreating) { this.createGeoMarker() }
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public async selectedExistingGeoMarker() {
        await this.redeemExistingGeoMarker(this.selectedGeoMarker)
    }

    public async createGeoMarker() {
        this.validationErrors = [];
        await this.getFormData();
    }

    public async redeemExistingGeoMarker(selectedGeoMarker: string = null) {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        var geoMarkerIdMaster = this.geoMarker.idMaster;

        if (selectedGeoMarker) {
            geoMarkerIdMaster = selectedGeoMarker;
        }

        try {
            await Axios.post(this.routes.MyBremboPartsExpert_SendGeoMarkerAssociationRequest, { geoMarkerIdMaster: geoMarkerIdMaster });

            this.isSuccess = true;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public async getFormData() {
        const result = (await Axios.post(this.routes.MyBremboPartsExpert_GetExpertFormData)).data;
        this.geoMarkerTypes = result.geoMarkerTypes;

        this.isCreating = true;
    };

    public selectGeoMarker(idMaster: string) {
        this.selectedGeoMarker = idMaster;
    }

    public async submitGeoMarker() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        this.formData.googlePlaceId = this.geoMarker.googlePlaceId;

        try {
            await Axios.post(this.routes.MyBremboPartsExpert_SaveExpertGeoMarker, this.formData);

            this.isCreating = false;
            this.isSuccess = true;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};